<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import LocationPin from '@athena-lib/Icons/LocationPin.svelte';

  export type ShippingDetails = {
    country?: string;
    postalCode?: string;
  };

  type ShipToProps = {
    shippingDetails?: ShippingDetails;
    onClick: () => void;
  };

  const { onClick, shippingDetails }: ShipToProps = $props();

  const translations = getCommonTranslations();
</script>

<button type="button" onclick={onClick} class="flex items-center gap-2">
  <LocationPin sizeClass="size-4" />

  <span
    >{[shippingDetails?.country, shippingDetails?.postalCode].filter(Boolean).join('-') ||
      translations.shipTo}</span
  >
</button>
